import React, { useState } from 'react';

const PWD = 'leomara';

function App() {
  const [password, setPassword] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [showError, setShowError] = useState(false);

  const checkPassword = () => {
    if (password === PWD) {
      setShowResult(true);
    } else {
      setShowError(true);
    }
  }

  const input = <div className={showError ? 'input error' : 'input'}>
    <form onSubmit={e => {
      e.preventDefault();
      checkPassword();
    }}>
      <input
        type="text"
        placeholder="Passwort..."
        value={password}
        onInput={e => setPassword(e.target.value)}
      />
      {showError ? <div className="error-text">Erneut versuchen!</div> : null}
      <button type="submit">Absenden</button>
    </form>
  </div>;

  const result = <div className="result">
    Wenn Timo Boll ohnmächtig wird, findet er den nächsten Umschlag vielleicht, wenn er wieder aufwacht.
  </div>

  return (
    <div className="app">
      <div className="wrapper">
        {showResult === false ? input : null}
        {showResult === true ? result : null}
      </div>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js